// Swaps the product-page breadcrumb's middle crumb from the product type to the
// customer's vehicle when they reached the product from a vehicle context.
//
// Liquid can't see this: query strings aren't exposed to Liquid, and the active
// vehicle lives in localStorage, so the whole thing has to happen client-side.
// sections/breadcrumbs.liquid renders the trail with an empty parent slot that
// this script fills.
//
// Two halves:
//   1. On a vehicle context page (the /vehicles/ metaobject page, or a
//      collection filtered by a car:/caryear: fitment tag) we record the crumb
//      on every outgoing product link click, along with the page it came from.
//   2. On the product page we use it only when document.referrer still matches
//      that recorded page. That's what makes it mean "arrived from here" rather
//      than "has a vehicle saved" — browse away and the trail reverts to the
//      product type on its own, with no cleanup pass needed.

const CRUMB_KEY = 'tapsy:vehicle-crumb';
const ACTIVE_VEHICLE_KEY = 'tapsy:active-vehicle';
const FITMENT_TAG = /^car(year)?:/;

function readJSON(store, key) {
  try {
    return JSON.parse(store.getItem(key) || 'null');
  } catch {
    return null;
  }
}

// Compare without the hash — an in-page anchor shouldn't break the match.
function sameDocument(a, b) {
  if (!a || !b) return false;
  try {
    const left = new URL(a);
    const right = new URL(b);
    return left.origin === right.origin && left.pathname === right.pathname && left.search === right.search;
  } catch {
    return false;
  }
}

// "car:ford-everest" -> "Ford Everest". Only used when the tag doesn't match the
// vehicle the customer picked in the header drawer, which carries proper casing.
function labelFromTag(tag) {
  const active = readJSON(localStorage, ACTIVE_VEHICLE_KEY);
  if (active?.brandSlug && active?.modelSlug && tag.includes(`${active.brandSlug}-${active.modelSlug}`)) {
    return `${active.brand} ${active.model}${active.year ? ` ${active.year}` : ''}`;
  }

  return tag
    .replace(FITMENT_TAG, '')
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** The vehicle this page represents, or null if it isn't a vehicle context. */
function pageVehicle() {
  const vehiclePage = document.querySelector('[data-vehicle-page][data-vehicle-label]');
  if (vehiclePage) {
    return {
      label: vehiclePage.dataset.vehicleLabel,
      url: vehiclePage.dataset.vehicleUrl || location.pathname,
    };
  }

  const tag = new URLSearchParams(location.search).get('filter.p.tag');
  if (tag && FITMENT_TAG.test(tag)) {
    return { label: labelFromTag(tag), url: location.pathname + location.search };
  }

  return null;
}

function recordOnProductLinks(vehicle) {
  // Capture phase: the card's own click handlers may navigate or stop propagation.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.('a[href*="/products/"]');
      if (!link) return;

      try {
        sessionStorage.setItem(CRUMB_KEY, JSON.stringify({ ...vehicle, from: location.href }));
      } catch {
        /* private mode — the trail just falls back to the product type */
      }
    },
    { capture: true }
  );
}

function applyToBreadcrumbs(nav) {
  const crumb = readJSON(sessionStorage, CRUMB_KEY);
  if (!crumb?.label || !sameDocument(document.referrer, crumb.from)) return;

  const slot = nav.querySelector('[data-breadcrumbs-parent]');
  const link = slot?.querySelector('[data-breadcrumbs-parent-link]');
  if (!slot || !link) return;

  link.textContent = crumb.label;
  link.href = crumb.url;
  slot.hidden = false;
}

const vehicle = pageVehicle();
if (vehicle) recordOnProductLinks(vehicle);

const breadcrumbs = document.querySelector('[data-breadcrumbs]');
if (breadcrumbs) applyToBreadcrumbs(breadcrumbs);
